// extracted by mini-css-extract-plugin
module.exports = {"actions":"_82e3db2ea0--actions--gDlIm","get-consultation":"_82e3db2ea0--get-consultation--bj2S5"};